import { Slide, toast } from "react-toastify";

export const showToast = (
  message,
  type = "success",
  position = "top-center"
) => {
  toast[type](message, {
    position: position,
    autoClose: 4000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
    transition: Slide,
  });
};
